
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import { ValidationProvider } from 'vee-validate';
import { getQuestionRules } from '@/utils/custom-questions';
import '@/validation-rules';

@Component({
	components: { ValidationProvider }
})
export default class AdditionalDetailsSection extends Vue {
	@Prop({ type: Array, required: true }) private questions!: CustomQuestion[];

	/**
	 * Generate time options in 15-minute intervals across a 24-hour period,
	 * formatted according to the current locale's time format
	 *
	 * @return {{ label: string; value: string }[]}
	 */
	private get timeOptions(): { label: string; value: string }[] {
		const options: { label: string; value: string }[] = [];
		const format = this.$t('menu.landing.time_format');
		for (let h = 0; h < 24; h++) {
			for (let m = 0; m < 60; m += 15) {
				const time = DateTime.fromObject({ hour: h, minute: m });
				options.push({ label: time.toFormat(format), value: `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}` });
			}
		}
		return options;
	}

	/**
	 * Format a select_one question's options into v-select compatible objects, using localized labels when available
	 *
	 * @param {QuestionWithOptions} question
	 * @return {{ index: number; label: string }[]}
	 */
	private formatDropdownOptions(question: QuestionWithOptions): { index: number; label: string }[] {
		const localizedOptions: string[] | undefined = this.$options.filters?.localize(question, 'options');
		if (localizedOptions?.length) {
			return localizedOptions.map((option: string, index: number) => ({ index, label: option }));
		}
		return question.options.map((option: string, index: number) => ({ index, label: option }));
	}

	private questionRules(question: CustomQuestion): Record<string, any> | string {
		return getQuestionRules(question);
	}
}
